// src/pages/Departments.js
import React from 'react';
import './Departments.css';

function Departments() {
  return (
    <div className="departments">
      <h1>Departments</h1>
      <p>List of departments and their associated OKRs.</p>
      <div className="department-container">
        <div className="department-item">
          <h3>Sales Department</h3>
          <p>Department OKRs: Increase sales by 10% in Q2.</p>
        </div>
        <div className="department-item">
          <h3>Support Department</h3>
          <p>Department OKRs: Achieve a 95% response rate for customer support.</p>
        </div>
        {/* More departments */}
      </div>
    </div>
  );
}

export default Departments;
